const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

export const isDebugging = urlParams.has('debug');
